import * as yup from 'yup'

export const societyFacilityNotificationEmailsCreateSchema = yup
  .object({
    primaryRecipient: yup.string(),
    ccEmails: yup.array(yup.string()),
  })
  .required()
